const selector = (state) => state.get('tariffs');

export const loadingSelector = (state) => selector(state).get('loading');

export const tariffsSelector = (state) => selector(state).get('tariffs');
